import { AutodeskSSOModel } from 'api/models';
import axios from 'axios';
import { getApiUrl } from 'config/api-url';
import http from 'config/http';

export const getAutodeskSSOAuthUrl = async () => {
    const { data } = await axios.get<{ authUrl: string }>(`${getApiUrl()}/sso/autodesk/auth-url`);

    return data;
};

export const getAutodeskSSO = async () => {
    const { data } = await http.get(`${getApiUrl()}/sso/autodesk`);

    return data ? AutodeskSSOModel.fromObject(data) : null;
};

export const authorizeAutodeskSSO = async (payload: { code: string; redirectUri: string }) => {
    const { data } = await http.post(`${getApiUrl()}/sso/autodesk/authorize`, {
        code: payload.code,
        redirectUri: payload.redirectUri,
    });
    return AutodeskSSOModel.fromObject(data);
};

export const unauthorizeAutodeskSSO = async () => {
    await http.delete(`${getApiUrl()}/sso/autodesk/unauthorize`);
};

export const authenticateAutodeskSSO = async (payload: { code: string; redirectUri: string }) => {
    try {
        const { data } = await axios.post(`${getApiUrl()}/sso/autodesk/authenticate`, {
            code: payload.code,
            redirectUri: payload.redirectUri,
        });
        return data as {
            token: string;
            hasMultipleAccounts: boolean;
        };
    } catch (err: any) {
        throw err.response || new Error('Something went wrong.');
    }
};

export const onBoardingAuthenticateAutodesk = async (payload: { code: string; redirectUri: string }) => {
    try {
        const { data } = await axios.post(`${getApiUrl()}/sso/autodesk/user-info`, {
            code: payload.code,
            redirectUri: payload.redirectUri,
        });

        return data as {
            id: string;
            email: string;
            name: string;
            dp: string;
        };
    } catch (err: any) {
        throw err.response || new Error('Something went wrong.');
    }
};
